import ApiClient from './ApiClient';

class PhoneCredentialsAPI extends ApiClient {
  constructor() {
    super('phone_credentials', {
      accountScoped: true,
    });
  }

  getCredentials() {
    return this.get();
  }
}

export default new PhoneCredentialsAPI();
